import type { DeleteSiteSectionProgrammingRangeCommand } from "@/domains/v4b/site-programming-range/site-programming-range.types";

import { useMutation, useQueryClient } from "@tanstack/vue-query";

import { useServices } from "@/configuration/plugins/app/app-provider.configuration";
import { SiteProgrammingRangeMutationKeys } from "@/data/api/v4b/site-programming-range/site-programming-range-mutation-keys";
import { SiteProgrammingRangeQueryKeys } from "@/data/api/v4b/site-programming-range/site-programming-range-query-keys";

export function useDeleteSiteProgrammingRangeMutation() {
  const v4b = useServices().v4b.clientSdk;
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: SiteProgrammingRangeMutationKeys.delete(),
    mutationFn: ({ siteId, sectionId, programmingRangeUuid }: DeleteSiteSectionProgrammingRangeCommand) => {
      return v4b.siteProgrammingRange.delete(siteId, sectionId, programmingRangeUuid);
    },
    onSettled: async (_data, _error, { siteId }) => {
      await queryClient.invalidateQueries({
        queryKey: SiteProgrammingRangeQueryKeys.findPlanning(siteId),
      });
    },
    retry: 0,
  });
}
